import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoMdSkipBackward } from "react-icons/io";
import { useTranslation } from "react-i18next";

const BackToHomeBtn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const backToDetails = () => navigate("/booking-details");
  return (
    <button
      className="btnRounded mb-2 d-flex align-items-center gap-2"
      onClick={backToDetails}
    >
      <IoMdSkipBackward /> <span>{t("other.goBack")}</span>
    </button>
  );
};

export default BackToHomeBtn;
